import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

interface BreadCrumbProps {
    title: string;
    pageTitle : string;
    pageLink?: string;
    description?: string;
}

const BreadCrumb = ({ title, pageTitle, pageLink = "#", description } : BreadCrumbProps) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between gap-3">
                        <div>
                            <h4 className={`mb-sm-0 ${description ? "mb-1" : ""}`.trim()}>{title}</h4>
                            {description ? <p className="text-muted mb-0">{description}</p> : null}
                        </div>

                        <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to={pageLink}>{pageTitle}</Link></li>
                                    <li className="breadcrumb-item active">{title}</li>
                                </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;
